import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useState, useCallback } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import useMergedRef from '@react-hook/merged-ref';
import { Input } from './input.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StatefulInput = forwardRef((_a, ref) => {
  var _b = _a, { defaultValue, onChange } = _b, props = __objRest(_b, ["defaultValue", "onChange"]);
  const internalRef = useRef(null);
  const mergedRef = useMergedRef(ref, internalRef);
  const [value, setValue] = useState(defaultValue != null ? defaultValue : "");
  const handleOnChange = useCallback((event) => {
    onChange == null ? void 0 : onChange(event);
    setValue(event.currentTarget.value);
  }, [onChange]);
  useIsomorphicLayoutEffect(() => {
    if (typeof defaultValue === "undefined") {
      setValue((prev) => {
        var _a2, _b2;
        return (_b2 = (_a2 = internalRef.current) == null ? void 0 : _a2.value) != null ? _b2 : prev;
      });
    }
  }, []);
  return jsx(Input, __spreadValues({ ref: mergedRef, value, onChange: handleOnChange }, props));
});

export { StatefulInput };
